module.exports = __webpack_public_path__ + "static/media/promo-title.03a1616e.svg";